import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

// Global reset — remove browser default margin/padding
const style = document.createElement('style');
style.textContent = '*, *::before, *::after { box-sizing: border-box; } html, body, #root { margin: 0; padding: 0; width: 100%; }';
document.head.appendChild(style);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
